import api from "../../../../utils/api";

const LeadApi = {
  // get all leads
  async fetchLeads(params = {}) {
    const { queryString, queryParams, signal, ...restParams } = params; // Ignore unwanted params
    const response = await api.get(
      `/enrollment?${queryString}&${queryParams}`,
      {
        params: restParams,
        signal,
      }
    );
    return { data: response?.data };
  },

  // get lead by id
  async fetchLead(leadId, params = {}) {
    const response = await api.get(`/enrollment/${leadId}`, { params });
    return response?.data?.data;
  },

  // add a lead
  async addLead(leadData) {
    const response = await api.post("/enrollment", leadData);

    return response?.data;
  },

  // update a lead
  async updateLead(id, leadData) {
    const response = await api.patch(
      `/enrollment/${id}?populate=ofCompany,assignedTo,lastUpdationBy&selectPopulate=name`,
      leadData
    );
    return response.data;
  },

  async changleLeadOwner(leadIdList, callerId) {
    const response = await api.patch(
      `/enrollment/operation/bulk-enrollment-assignment`,
      {
        callerId,
        leadIdList,
      }
    );
    return response.data;
  },

  async getFinencialPlanningPdfForEnrollment(leadId) {
    const response = await api.get(
      `/profiling-form/generate-financial-report-pdf/${leadId}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  },

  // fetchLeadsWithQuery for leads dashboard
  async fetchLeadsWithQuery(params = {}) {
    const { queryKey, signal, ...restParams } = params; // Ignore unwanted params
    const response = await api.get("/analytics/lead", {
      params: restParams,
      signal,
    });
    return { data: response?.data };
  },
};

export default LeadApi;
